import React from 'react';
import userImg from 'assets/images/user.png';

interface AccountInfoProps {
  photoUrl?: string;
  name: string;
  role: string;
}

const AccountInfo: React.FC<AccountInfoProps> = ({ photoUrl, name, role }) => {
  return (
    <div className="flex gap-2 items-center">
      <div className="w-[40px] h-[40px] border-2 border-white rounded-[40px] overflow-hidden">
        <img
          src={photoUrl || userImg}
          alt="uw_profile"
          className="w-full h-full object-cover"
        />
      </div>
      <div>
        <p className="text-[16px]">{name}</p>
        <p className="text-[12px] font-thin text-[#5E6B7C]">{role}</p>
      </div>
    </div>
  );
};

export default AccountInfo;
